import { React, useState } from "react";
import "animate.css";
import {
	Box,
	Typography,
	Container,
	useMediaQuery,
	useTheme,
} from "@mui/material";

import CasinoIcon from "@mui/icons-material/Casino";
import LoadingButton from "@mui/lab/LoadingButton";

function DishRoulette() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [emoji, setEmoji] = useState("");
	const [link, setLink] = useState("");

	const getRandomPageCB = async () => {
		setLoading(true);
		try {
			const res = await fetch(
				`https://us-central1-mealplanner-f6b88.cloudfunctions.net/api/random-notion-page`
			);
			const data = await res.json();
			if (res.ok) {
				setTitle(data.title);
				setEmoji(data.emoji);
				setLink(data.externalUrl || data.notionUrl);
				//console.log("Random Page:", data);
			} else {
				setTitle("Error: " + data.message);
				setEmoji("❌");
			}
		} catch (err) {
			setTitle("Error fetching page");
		} finally {
			setLoading(false);
		}
	};
	return (
		<div className="Landing animate__animated animate__fadeIn animate__slow">
			<Container
				sx={{
					display: "flex",
					flexDirection: "column", // stack children vertically
					justifyContent: "center", // vertical centering
					alignItems: "center", // horizontal centering
					height: "100vh", // full viewport height (or any height you want)
					textAlign: "center",
				}}
			>
				<Box
					className="Landing-heading"
					sx={{
						textAlign: { xs: "center", md: "center" },
						paddingTop: { xs: 5 },
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: 0.5, // <-- controls spacing between children
					}}
				>
					<Typography
						variant="h2"
						className="colorText"
						sx={{
							fontSize: { xs: "2rem", md: "3rem" },
							fontWeight: "bold",
							color: "#333",
							marginBottom: 0, // Remove bottom margin
						}}
					>
						Dish{" "}
						<span className={isMobile ? "colorText" : "colorText"}>Roulette</span>
					</Typography>
					<Typography sx={{ marginTop: 0 }} variant="overline">
						Meal of the day
					</Typography>
				</Box>

				{loading || emoji === "" || null ? (
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							height: "300px",
							width: "300px",
							justifyContent: "center", // vertical centering
							alignItems: "center",
							//backgroundColor: green[200],
							gap: 2,
						}}
					>
						<CasinoIcon
							className={
								loading ? "animate__animated animate__wobble animate__infinite" : ""
							}
							sx={{ fontSize: "5em" }}
						/>
						{loading ? (
							""
						) : (
							<Typography variant="overline">Spin to reveal your dish</Typography>
						)}
					</Box>
				) : (
					<Box
						component="a"
						href={link}
						target="_blank"
						rel="noopener noreferrer"
						sx={{
							textDecoration: "none", // removes underline
							color: "inherit", // inherits current text color
							cursor: "pointer", // optional: keeps pointer for UX
							"&:hover": {
								textDecoration: "none", // ensure no underline on hover
							},
							display: "flex",
							flexDirection: "column",
							height: "300px",
							width: "300px",
							justifyContent: "center", // vertical centering
							alignItems: "center",
							//backgroundColor: green[200],
						}}
					>
						<Typography sx={{ fontSize: "5em" }}>{emoji}</Typography>
						<Typography sx={{ fontSize: "1em" }} variant="overline">
							{title}
						</Typography>
					</Box>
				)}
				<LoadingButton
					onClick={getRandomPageCB}
					loading={loading}
					size="large"
					variant="contained"
				>
					Spin
				</LoadingButton>
			</Container>
		</div>
	);
}
export default DishRoulette;
